import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { LoanRequest } from 'src/model/loanRequest.model';

@Component({
    selector: 'app-authorize-loan-request',
    templateUrl: './authorize-loan-request.component.html',
    styleUrls: ['./authorize-loan-request.component.scss'],
    standalone: false
})
export class AuthorizeLoanRequestComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);


  @Input() request: LoanRequest;
  @Input() onlyViewLoan = false;

  @Input() requestList: LoanRequest[] = [];

  disabledSubmit = false;

  remark = "";

  ngOnInit(): void {

  }


  confirmBeforeAction() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you confirm to authorize loan TICKET #" + this.request.ID + "?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.authorize();
    });
  }


  authorize() {
    const xhr = this.restApi.putRequest(this.constructApi.getAuthorizeLoanApprovalRequest(this.request.ID));
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        window.location.reload();
      }
    }
  }


  reset() {
    this.activeModal.close();
  }
}
